import { render, staticRenderFns } from "./Owner.vue?vue&type=template&id=10b8a7d3&scoped=true&"
import script from "./Owner.vue?vue&type=script&lang=js&"
export * from "./Owner.vue?vue&type=script&lang=js&"
import style0 from "./Owner.vue?vue&type=style&index=0&id=10b8a7d3&lang=less&scoped=true&"
import style1 from "./Owner.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8a7d3",
  null
  
)

export default component.exports